import React, {useState , useContext, useCallback, useEffect} from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import InputMask from 'react-input-mask';
import Modal from './Modal'
import { ModalContext } from "../../context"
import {fetchRegistration} from '../../api/api'
import { FORM, ERRORS_FORM_REGISTRATION } from '../../constant'
import css from './Modal.module.scss'
import lCss from '../Layout/Layout.module.scss'

export default function ModalRegistration({isOpen,closeModal}) {
	const [form, setForm] = useState({[FORM.FIRST_NAME]: '', [FORM.LAST_NAME]: '', [FORM.EMAIL]: '', [FORM.COMPANY]: '', [FORM.PHONE]: '', [FORM.RECAPTCHA]: '',[FORM.POLICY]: false})
	const [state, setState] = useState({error: '', focus: ''})
	const { executeRecaptcha } = useGoogleReCaptcha();
	const { toggleModal } = useContext(ModalContext)
	const { error, focus} = state

	const onChange = (e) => {
		const { name, value } = e.target
		setForm(prevState => ({...prevState, [name]: value}))
		setState(prevState => ({...prevState, error: '' }))
	}

	const onCheckbox = (e) =>{
		const { name, checked } = e.target

		setForm(prevState => ({...prevState, [name]: checked}))
		setState(prevState => ({...prevState, error: '' }))
	}

	const onFocus = (e) => {
		const { name } = e.target
		setState(prevState => ({...prevState, focus: name }))
	}


	const onSubmit = async (e) =>{
		e.preventDefault()
		if(!validate()){
			const token = await handleReCaptchaVerify();
			const result = await fetchRegistration({...form,...{[FORM.RECAPTCHA]: token}})
			if (result?.message?.code === 200) {
				toggleModal({registration:false, registrationSuccess:true})
			} else {
				toggleModal({registration:false, error: true})
			}
		}
	}

	const validate = () =>{
		const error = Object.keys(ERRORS_FORM_REGISTRATION).find(e => (form[e] === '' || !form[e]))
		setState(prevState => ({...prevState, error: ERRORS_FORM_REGISTRATION[error] }))

		return Boolean(error)
	}

	const handleReCaptchaVerify = async () => {
		if (!executeRecaptcha) {
			console.log('Execute recaptcha not yet available')
		}else {
			try {
				const token = await executeRecaptcha('load');
				setForm(prevState => ({...prevState, [FORM.RECAPTCHA]: token}));
				return token;
			} catch (e) {
				handleReCaptchaVerify()
			}
		}
	}

	useEffect(() => {
		handleReCaptchaVerify()
	}, [executeRecaptcha])

	return (
		<Modal
			isOpen={isOpen}
			closeModal={closeModal}
			style={{
				content: {
					position:'static',
					display: 'inline-block',
					background: '#fff',
					overflow: 'auto',
					border: 'none',
					WebkitOverflowScrolling: 'touch',
					outline: 'none',
					boxShadow: '5px 15px 25px rgba(0, 0, 0, 0.5)',
					borderRadius: 'none',
					padding: '0',
					width:'480px',
					maxWidth: '100%',
					margin: '0 auto'
				}
			}}
		>
			<>
				<div className={css.title + ' ' + css.login}>Подключить тестовый доступ</div>
				<form onSubmit={onSubmit}>
					<label
						className={css.field + ' ' + (focus === FORM.FIRST_NAME ? css.focus : '') + ' ' + (form[FORM.FIRST_NAME] ? css.hasValue : '')}>
						<span className={css.label}>Имя</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.FIRST_NAME]}
							name={FORM.FIRST_NAME}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label
						className={css.field + ' ' + (focus === FORM.LAST_NAME ? css.focus : '') + ' ' + (form[FORM.LAST_NAME] ? css.hasValue : '')}>
						<span className={css.label}>Фамилия</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.LAST_NAME]}
							name={FORM.LAST_NAME}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label
						className={css.field + ' ' + (focus === FORM.EMAIL ? css.focus : '') + ' ' + (form[FORM.EMAIL] ? css.hasValue : '')}>
						<span className={css.label}>E-mail</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.EMAIL]}
							name={FORM.EMAIL}
							type="email"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label
						className={css.field + ' ' + (focus === FORM.COMPANY ? css.focus : '') + ' ' + (form[FORM.COMPANY] ? css.hasValue : '')}>
						<span className={css.label}>Название организации</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.COMPANY]}
							name={FORM.COMPANY}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label
						className={css.field + ' ' + (focus === FORM.PHONE ? css.focus : '') + ' ' + (form[FORM.PHONE] ? css.hasValue : '')}>
						<span className={css.label}>Телефон</span>
						<InputMask
							className={css.input}
							autoComplete="off"
							mask="+7 (999) 999-99-99"
							value={form[FORM.PHONE]}
							name={FORM.PHONE}
							type="tel"
							onFocus={onFocus}
							onChange={onChange}
						/>
					</label>
					<label
						className={css.field + ' ' + (focus === FORM.REFERER ? css.focus : '') + ' ' + (form[FORM.REFERER] ? css.hasValue : '')}>
						<span className={css.label}>Откуда Вы узнали о нас?</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.REFERER]}
							name={FORM.REFERER}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<div className={css.field}>
						<label className={css.checkbox}>
							<input className={css.checkboxField} type="checkbox" name={FORM.POLICY}
								   onChange={onCheckbox}/>
							<i className={css.checkboxIcon}/>
							<span className={css.checkboxTitle}>Даю согласие на обработку моих персональных данных, с использованием средств автоматизации или без использования таковых, а именно: сбор, запись, хранение, уточнение, распространение, Федеральному Государственному Унитарному Предприятию МИА «Россия сегодня», расположенному по адресу: Россия, 119034, г. Москва, Зубовский бульвар, д. 4.</span>
						</label>
					</div>
					<div className={css.field}>
						{error
							? <div
								className={lCss.button + ' ' + lCss.mt20 + ' ' + lCss.w100 + ' ' + lCss.error}>{error}</div>
							: <button className={lCss.button + ' ' + lCss.mt20 + ' ' + lCss.w100}>
								Отправить
							</button>
						}
					</div>
				</form>
			</>
		</Modal>
	)
}